declare var Swal;

namespace AgerLMS.SweetAlert {
    
    //swal örnekleri
    //https://sweetalert2.github.io/#input-types
    //https://sweetalert2.github.io/recipe-gallery/

    export function swal_success(title: string, text: string) {
      Swal.fire(
        title,
        text,
        'success'
      )
    }

    export function swal_loading(title: string) {
      Swal.fire({
        title: title,
        allowOutsideClick: false,
        allowEnterKey: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading()
        },
      })
    }

    //loading close
    export function swal_close() {
      Swal.close();
    }

    export function swal_success_then(title: string, text: string, then: ()=> void) {
      Swal.fire(
        title,
        text,
        'success',
      ).then(then)
    }

    export function swal_success_then2(title: string, confirm: ()=> void, deny: ()=> void) {
      Swal.fire({
        title: title,
        icon: 'success',
        showDenyButton: true,
        denyButtonText: "Alışverişe Devam Et",
        confirmButtonText: "<i class='fa fa-shopping-cart fa-fw fa-lg'></i> Sepete Git",
        confirmButtonColor: "green",
      }).then((result) => {
        if (result.isConfirmed) {
          confirm();
        } else if (result.isDenied) {
          deny();
        }
      });
    }

    export function swal_alert(title: string, text: string) {
        Swal.fire({
            title: title,
            text: text,
            icon: 'error',
            timer: 3500,
            confirmButtonColor: "#4d79f6",
            confirmButtonText: "Kapat",
        }).then(function () { },
            function (dismiss) {
            });
    }

    export function swal_warning(title: string, text: string) {
      Swal.fire({
          title: title,
          html: text,
          icon: 'warning',
          confirmButtonColor: "#4d79f6",
          confirmButtonText: "Kapat",
          allowOutsideClick: false,
          allowEscapeKey: false
      }).then(function () { },
          function (dismiss) {
          });
  }

    export function swal_info_html(title: string, html: string) {
      Swal.fire({
        title: title,
        icon: 'info',
        html: html,
        showCloseButton: true
      })
    }

    export function swal_info(title: string, text: string) {
      Swal.fire(
        title,
        text,
        'info'
      )
    }

    export function swal_info_then(title: string, text: string, then: ()=> void) {
      Swal.fire(
        title,
        text,
        'info'
      ).then(then)
    }

    export function swal_confirm(title: string, text: string, confirm: ()=> void) {
        Swal.fire({
            title: title,
            html: text,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Evet',
          }).then((result) => {
            if (result.isConfirmed) {
              confirm();
            }
          })
    }
}
